import { Box } from "@material-ui/core";

export function Row(props: { children: React.ReactNode }) {
	return (
		<Box my={2}>
			{props.children}
		</Box>
	);
}

// TODO-MPA: async with setState doens't works - Have to find solution
//export function CustomButton(props: { onClick: () => void, variant: string, color?: string, className?: string, fullWidth?: boolean, text: string }) {
//	const [disabled, setDisabled] = useState(false);

//	const handleOnClick = (event: any) => {
//		const target = event.currentTarget as unknown as HTMLElement;
//		console.log(event);
//		console.log(target.getAttribute("disabled"));

//		var button1 = document.getElementById('button1') as unknown as HTMLElement;
//		button1.setAttribute('disabled', "true");

//		//var button1 = document.getElementById("button1") as unknown as JSX.Element;
//		//target.disabled = true;
//	}


//	return (
//		<Button data-name="button" id="button1" variant={props.variant as any} color={props.color as any} onClick={handleOnClick}>{props.text}</Button>
//	);
//}